import script from "./AdminWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminWarning.vue?vue&type=script&setup=true&lang=js"

import "./AdminWarning.vue?vue&type=style&index=0&id=5ebe127a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ebe127a"]])

export default __exports__